<template>
  <div>
    <div
      id="browser-version"
      class="box-tips-msg"
    >
      <span class="tips">
        <!-- eslint-disable-next-line max-len -->
        {{ $t('温馨提示：您当前的浏览器版本过低，请尝试使用谷歌浏览器（Chrome）或者联系IT客服（8533）6000将当前IE浏览器设置为非兼容模式。') }}
      </span>
      <span
        class="icon-close close"
        @click="closeBrowserVersion"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'BoxTips',
  data() {
    return {}
  },
  methods: {
    closeBrowserVersion() {
      this.$emit('closeVersionTip')
    },
  },
}
</script>
<style lang="less">
@import '~less/variable.less';

.box-tips-msg {
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 44px;
  line-height: 44px;
  text-align: center;
  background: #fff;
  color: @mainFontColor;
  word-break: break-all;
  .tips{
    width: 100%;
    display: inline-block;
    box-sizing: border-box;
    vertical-align: middle;
    background: #F6F7FA;
  }
  a {
    color: @mainColor;
    cursor: pointer;
  }
  .icon-close {
    background: url(~image/close.svg) 4px 4px no-repeat;
  }
  .close {
    position: absolute;
    display: inline-block;
    right: 20px;
    top: 12px;
    z-index: 20;
    cursor: pointer;
    width: 20px;
    height: 20px;
    color: @mainFontColor;
  }
}
.new-client-version {
  .box-tips-msg {
    position: fixed;
    background-color: rgb(252,234,189);
    color: rgb(206,161,53);
    height: 40px;
    line-height: 40px;
    border-radius: 2px;
    z-index: 9999;
    .close {
      top: 12px;
      color: #1b2733;
    }
  }
}
</style>
